import React, {Component} from "react";

import Header from "./include/header";
import Player from "./include/player";
import {HashRouter, Route, Switch} from "react-router-dom";
import Channel from "./channel";
import {isLogin, rd, route, routes} from "../vars/rd";
import NotFoundOther from "./error/not.found.other";
import Broadcast from "./broadcast";
import SearchChannel from "./search/search.channel";
import SearchBusiness from "./search/business";
import SearchTheme from "./search/theme";
import SearchGenre from "./search/genre";
import SearchResultChannel from "./search/result.channel";
import Notice from "./notice";
import Mypage from "./mypage";
import Setting from "./setting";
import CSCenter from "./cscenter";
import EventLogs from "./event.logs";
import MySchedule from "./mypage/schedule";
import MyChannel from "./mypage/channel";
import SearchResultMent from "./search/result.ment";
import SearchMent from "./search/search.ment";

class Main extends Component {
    constructor(props) {
        super(props);

        if(!isLogin()) route(routes.login);
    }

    render() {
        return (
            <HashRouter>
                <div className={'app-body'}>
                    {/* Header */}
                    <Header user={rd.user} />

                    {/* Main Content */}
                    <Switch>
                        {/* 채널 */}
                        <Route exact={true} path={routes.main} component={Channel}></Route>
                        {/* 안내광고방송 */}
                        <Route exact={true} path={routes.broadcast} component={Broadcast}></Route>
                        {/* 검색(채널) */}
                        <Route exact={true} path={routes.search_channel} component={SearchChannel}></Route>
                        {/* 검색(광고방송) */}
                        <Route exact={true} path={routes.search_ment} component={SearchMent}></Route>
                        {/* 검색-업종별 */}
                        <Route path={routes.search_business} component={SearchBusiness} key={window.location.pathname}></Route>
                        {/* 검색-테마별 */}
                        <Route path={routes.search_theme} component={SearchTheme}></Route>
                        {/* 검색-장르별 */}
                        <Route path={routes.search_genre} component={SearchGenre}></Route>
                        {/* 검색-결과(채널) */}
                        <Route path={routes.search_result_channel} component={SearchResultChannel}></Route>
                        {/* 검색-결과(광고방송) */}
                        <Route path={routes.search_result_ment} component={SearchResultMent}></Route>
                        {/* 마이페이지 */}
                        <Route exact={true} path={routes.mypage} component={Mypage}></Route>
                        {/* 마이스케줄 */}
                        <Route exact={true} path={routes.myschedule} component={MySchedule}></Route>
                        {/* 마이채널 */}
                        <Route exact={true} path={routes.mychannel} component={MyChannel}></Route>
                        {/* 공지사항 */}
                        <Route path={routes.notice} component={Notice}></Route>
                        {/* 환경설정 */}
                        <Route exact={true} path={routes.setting} component={Setting}></Route>
                        {/* 고객센터 */}
                        <Route exact={true} path={routes.cscenter} component={CSCenter}></Route>
                        {/* 이벤트로그 */}
                        <Route exact={true} path={routes.event_logs} component={EventLogs}></Route>
                        {/* 404에러 */}
                        <Route path={routes.not_found_main} component={NotFoundOther}></Route>
                    </Switch>

                    {/* Player */}
                    <Player />
                </div>
            </HashRouter>
        );
    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/pages/main.jsx